import React from 'react'

function AttendancebyHour({ color = '#252C32', bgColor = 'white' }) {
    return (
        <>
            <svg width="24" height="24" viewBox="0 0 16 17" fill={bgColor} xmlns="http://www.w3.org/2000/svg">
                <path d="M8.00016 15.1673C11.6821 15.1673 14.6668 12.1825 14.6668 8.50065C14.6668 4.81875 11.6821 1.83398 8.00016 1.83398C4.31826 1.83398 1.3335 4.81875 1.3335 8.50065C1.3335 12.1825 4.31826 15.1673 8.00016 15.1673Z" stroke={color} />
                <path d="M8 5.83398V8.50065L9.33333 9.83398" stroke={color} stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </>
    )
}

export default AttendancebyHour